var ajaxCalls = require('./ajaxCalls');

var finish = function(exam,global) {

    clearInterval(global.timer);
    // update the answer
    var answer = global.response.answers[global.questionIndex];
    ajaxCalls.scoreExam(global.userId,global.examId,answer);

    var modalDiv = $('#'+ global.modal);
    $(modalDiv).on('hidden.bs.modal', function (e) {

        $(modalDiv).find('.modal-content').html('');
        document.location.href = sprintf(global.examReviewLink,{ examId:global.examId, userId:global.userId});
    });
    var modalcontentstr = '<div class="modal-header">Finish</div><div class="modal-body">' +
        'Your practice exam has be scored. Click review to see your score.';

    modalcontentstr += '</div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Review Exam</button></div>';
    var modalContent = $.parseHTML(modalcontentstr);

    $(modalDiv).find('.modal-content').append(modalContent);
    $(modalDiv).modal();

}

module.exports = finish;


//////////////////
// WEBPACK FOOTER
// ./src/finish.js
// module id = 319
// module chunks = 0